import { el } from '../dom'
import { COPY } from './copy'

export function createGuidedBlurb(opts: { onDone: () => void }): {
  root: HTMLElement
  open: () => void
  close: () => void
} {
  const done = el(
    'button',
    {
      className: 'guided-card__done',
      text: COPY.guidedDone,
      testId: 'guided-blurb-done',
      attrs: { type: 'button' },
    },
  )
  done.addEventListener('click', () => opts.onDone())

  const card = el('div', { className: 'gate-card guided-card', testId: 'guided-blurb-card' }, [
    el('h2', { className: 'gate-card__title', text: COPY.guidedTitle }),
    el('p', { className: 'guided-card__body', text: COPY.guidedBody }),
    done,
  ])

  const root = el(
    'div',
    {
      className: 'overlay overlay--blurb',
      testId: 'guided-blurb',
      attrs: { hidden: '' },
    },
    [card],
  )

  return {
    root,
    open: () => {
      root.hidden = false
    },
    close: () => {
      root.hidden = true
    },
  }
}
